import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  CreatePersonasProyectoDto,
  ProyectoDTO,
} from '../models/dbdtos.interface';
import {
  Proyecto,
  PersonasProyectos,
  PersonasProyectosConProyecto,
} from '../models/dbresponses.interface';
import {ViaCheckApiQueryService} from './via-check-api-query.service';
import {Tipo_estado} from '../models/db.enum';

@Injectable({
  providedIn: 'root',
})
export class ProjectsQuerysService extends ViaCheckApiQueryService {
  /* show 10 project you are allowed to see, filtered by progress of the project */
  public getProjects(
    pagina = 1,
    estado: (typeof Tipo_estado)[keyof typeof Tipo_estado]
  ): Observable<Proyecto[]> {
    const subdomain = `proyectos?pagina=${pagina}&estado=${estado}`;
    return this.networkRequest('get', subdomain);
  }

  public getSingleProject(id?: number): Observable<Proyecto> {
    const subdomain = `proyectos/${id}`;
    return this.networkRequest('get', subdomain);
  }

  public getProjectsByPerson(
    id: number,
    pagina = 1
  ): Observable<{
    activeProject: PersonasProyectosConProyecto[];
    finishedProject: PersonasProyectosConProyecto[];
    approvedProject: PersonasProyectosConProyecto[];
  }> {
    const subdomain = `personas/${id}/proyectos?pagina=${pagina}`;
    return this.networkRequest('get', subdomain);
  }

  public getProjectsByOrganisms(
    id: number,
    pagina = 1
  ): Observable<Proyecto[]> {
    const subdomain = `proyectos/organismo/${id}?pagina=${pagina}`;
    return this.networkRequest('get', subdomain);
  }

  public getProjectsByLicitation(
    codigoLicitacion: string
  ): Observable<Proyecto[]> {
    const subdomain = `proyectos/licitacion/${codigoLicitacion}`;
    return this.networkRequest('get', subdomain);
  }

  public postProject(proyecto: ProyectoDTO): Observable<Proyecto> {
    const subdomain = 'proyectos';
    return this.networkRequest('post', subdomain, proyecto);
  }

  public linkPersonToProject(
    dto: CreatePersonasProyectoDto
  ): Observable<PersonasProyectos> {
    const subdomain = 'proyectos/persona';
    return this.networkRequest('post', subdomain, dto);
  }

  public patchProject(
    id: number,
    proyecto: Proyecto | ProyectoDTO
  ): Observable<Proyecto> {
    const subdomain = `proyectos/${id}`;
    return this.networkRequest('patch', subdomain, proyecto);
  }

  public deleteProject(id: number): Observable<Proyecto> {
    const subdomain = `proyectos/${id}`;
    return this.networkRequest('delete', subdomain);
  }

  public deletePersonFromProject(
    projectID: number,
    personID: number
  ): Observable<Proyecto> {
    const subdomain = `proyectos/personas/${projectID}`;
    return this.networkRequest('delete', subdomain, {persona: personID});
  }
}
